import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import WOW from "wowjs";

function WorkingProcess() {
  const [serviceProcess, setServiceProcess] = useState(null);

  useEffect(() => {
    // Fetch data from the API
    fetch('https://solanthegroup.com/admin/api/service_process')
      .then(response => response.json())
      .then(data => {
        if (data.length > 0) {
          setServiceProcess(data[0]); // Assuming the API returns an array with a single object
        }
      })
      .catch(error => console.error('Error fetching service process:', error));

    // Initialize WOW.js
    const wow = new WOW.WOW({
      live: false, // This disables continuous scanning for new elements
    });
    wow.init();
  }, []);

  if (!serviceProcess) {
    return <div></div>; // Show a loading state while data is being fetched
  }

  return (
    <div>
      <div className="tpm-services-process-area tmp-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head">
                <div className="section-sub-title center-title">
                  <img src="assets/images/services/section-custom-menubar.png" alt="Corporate_service" />
                  <span className="subtitle">{serviceProcess.info_title}</span>
                </div>
                <h2 className="title split-collab">{serviceProcess.title}</h2>
              </div>
            </div>
          </div>

          <div className="row g-5">
            {/* First Container */}
            <div className="col-lg-4 col-md-6 col-sm-6 col-12 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".1s">
              <div className="single-services">
                <div className="services-inner">
                  <div className="thumbnail thumbnail-rounded border-top-left hover-animation">
                    <Link to="#">
                      <img src={`https://solanthegroup.com/admin/${serviceProcess.first_container_photo}`} alt="Business consulting services" />
                    </Link>
                    <div className="number-bg-round">
                      <span>01</span>
                    </div>
                  </div>
                  <div className="services-content services-content-style-1 text-center">
                    <h5 className="title" style={{textWrapMode: "nowrap"}}>{serviceProcess.first_container_title}</h5>
                    <p className="description">{serviceProcess.first_container_description}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Second Container */}
            <div className="col-lg-4 col-md-6 col-sm-6 col-12 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".2s">
              <div className="single-services">
                <div className="services-inner">
                  <div className="thumbnail thumbnail-rounded border-top-left hover-animation">
                    <Link to="#">
                      <img src={`https://solanthegroup.com/admin/${serviceProcess.second_container_photo}`} alt="Business consulting services" />
                    </Link>
                    <div className="number-bg-round">
                      <span>02</span>
                    </div>
                  </div>
                  <div className="services-content services-content-style-1 text-center">
                    <h5 className="title nowrap" style={{textWrapMode: "nowrap"}}>{serviceProcess.second_container_title}</h5>
                    <p className="description">{serviceProcess.second_container_description}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Third Container */}
            <div className="col-lg-4 col-md-6 col-sm-6 col-12 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".3s">
              <div className="single-services">
                <div className="services-inner">
                  <div className="thumbnail thumbnail-rounded border-top-left hover-animation">
                    <Link to="#">
                      <img src={`https://solanthegroup.com/admin/${serviceProcess.third_container_photo}`} alt="Business consulting services" />
                    </Link>
                    <div className="number-bg-round">
                      <span>03</span>
                    </div>
                  </div>
                  <div className="services-content services-content-style-1 text-center">
                    <h5 className="title" style={{textWrapMode: "nowrap"}}>{serviceProcess.third_container_title}</h5>
                    <p className="description">{serviceProcess.third_container_description}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>{`
        .services-content.services-content-style-1 .title {
          font-size: 24px;
        }
      `}</style>
    </div>
  );
}

export default WorkingProcess;